import React from 'react';
import s from './s.module.less';

// 可选字段标签（原型只标 Optional，必填不加标记）
export default function OptLabel({ children }: { children: React.ReactNode }) {
    return (
        <>
            {children} <span className={s.optional}>(Optional)</span>
        </>
    );
}
